import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _Box, _FallbackPatientFormS, _FallbackScheduleStep, _FallbackFormFieldsPa;
var _excluded = ["sx", "showPatientFormStepLoader", "isReschedule"];
import React from 'react';
import { Box, Container, Grid2, Paper, Skeleton, extendSX } from '@lumahealthhq/ui-core';
import { FallbackContainerStaffSchedulerSiderList, FallbackFormFieldsPatient, FallbackPatientFormStepLoader } from './components';
import FallbackScheduleStepLoader from './components/FallbackScheduleStepLoader';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FallbackContainerStaffScheduler(_ref) {
  var sx = _ref.sx,
    showPatientFormStepLoader = _ref.showPatientFormStepLoader,
    isRescheduleProp = _ref.isReschedule,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isReschedule = React.useMemo(function () {
    if (isRescheduleProp) return true;
    var searchParams = new URLSearchParams(window.location.search);
    var appointmentToReschedule = searchParams.get('appointmentToReschedule');
    return !!appointmentToReschedule;
  }, [isRescheduleProp]);
  return /*#__PURE__*/_jsxs(Container, _extends({
    maxWidth: false,
    disableGutters: true,
    sx: extendSX(sx, {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 6
    })
  }, rest, {
    children: [_Box || (_Box = /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(Skeleton, {
        variant: "text",
        height: 35,
        width: 200
      })
    })), /*#__PURE__*/_jsxs(Grid2, {
      container: true,
      rowGap: {
        xs: 3,
        md: 0
      },
      columnSpacing: {
        md: 4,
        lg: 6
      },
      gridTemplateRows: {
        xs: 'auto 1fr'
      },
      display: {
        xs: 'grid',
        md: 'flex'
      },
      sx: {
        flex: 1,
        pb: 5
      },
      children: [/*#__PURE__*/_jsx(Grid2, {
        md: "auto",
        sx: function sx(theme) {
          return _defineProperty({
            height: 'fit-content',
            position: 'sticky',
            top: 0,
            zIndex: 2
          }, theme.breakpoints.down('md'), {
            boxShadow: theme.shadows[1]
          });
        },
        children: /*#__PURE__*/_jsx(Box, {
          sx: {
            height: 'fit-content',
            width: '100%'
          },
          children: /*#__PURE__*/_jsx(Paper, {
            children: /*#__PURE__*/_jsx(FallbackContainerStaffSchedulerSiderList, {
              isReschedule: isReschedule
            })
          })
        })
      }), /*#__PURE__*/_jsx(Grid2, {
        md: true,
        children: /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsxs(Paper, {
            sx: {
              p: 5
            },
            children: [showPatientFormStepLoader && (_FallbackPatientFormS || (_FallbackPatientFormS = /*#__PURE__*/_jsx(FallbackPatientFormStepLoader, {}))), isReschedule && (_FallbackScheduleStep || (_FallbackScheduleStep = /*#__PURE__*/_jsx(FallbackScheduleStepLoader, {}))), !showPatientFormStepLoader && !isReschedule && (_FallbackFormFieldsPa || (_FallbackFormFieldsPa = /*#__PURE__*/_jsx(FallbackFormFieldsPatient, {})))]
          })
        })
      })]
    })]
  }));
}